module.exports = __webpack_public_path__ + "media/pregunta.04527708.mp3";